import React from 'react';
import styles from './ErrorModal.module.scss';
import { useSelector } from 'react-redux';

const ErrorModal = () => {
    const { errors } = useSelector(state => state.global.errorModal);

    return (
        errors.length > 0 && errors.map(error => <div className={styles.error}>{error.reason}</div>)
    );
};

export default ErrorModal;
